import { useState } from "react";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { Maximize2 } from "lucide-react";

interface TechMediaProps {
  src: string;
  alt: string;
  caption?: string;
  className?: string;
}

/** Responsive, tap-to-expand technical diagram viewer (labels stay readable on mobile). */
const TechMedia = ({ src, alt, caption, className = "" }: TechMediaProps) => {
  const [open, setOpen] = useState(false);

  return (
    <figure className={`relative ${className}`}>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
          <button
            type="button"
            aria-label={`Expand diagram: ${alt}`}
            className="group relative block w-full overflow-hidden rounded-2xl border border-[hsl(var(--line))] bg-white/5"
          >
            <img
              src={src}
              alt={alt}
              loading="lazy"
              className="w-full object-contain max-h-[70vh] transition-transform duration-500 group-hover:scale-[1.02]"
            />
            <span className="absolute bottom-3 right-3 inline-flex items-center gap-1.5 rounded-full bg-background/80 px-3 py-1.5 text-[11px] font-medium backdrop-blur">
              <Maximize2 className="h-3.5 w-3.5" /> Tap to expand
            </span>
          </button>
        </DialogTrigger>
        <DialogContent className="max-w-[96vw] sm:max-w-4xl p-2 sm:p-4">
          <div className="max-h-[85vh] overflow-auto">
            <img src={src} alt={alt} className="w-full h-auto" />
          </div>
        </DialogContent>
      </Dialog>
      {caption && (
        <figcaption className="mt-2 text-xs text-muted-foreground">{caption}</figcaption>
      )}
    </figure>
  );
};

export default TechMedia;
